const getHeaders = () => {
    var headers = {
        accesstoken: localStorage.getItem('token'),
        "Content-Type": "multipart/form-data"
    };
    return headers
}

export default getHeaders